<template>
  <div class="customers relative" :key="`contact-${$route.query ? $route.query.globalSearchKey : 0}`">
    <div class="add-button c-float m-b-20 flex is-flex-wrap">
      <div class="flex" style="flex-grow: 1">
        <p class="user-name">{{ $t('contacts') }}</p>
      </div>
      <Dropdown
        class="flex drop-right"
        :buttonText="$t('add')"
        :dropdownOptions="dropdownOptions"
        @optionSelected="optionSelected" />
    </div>
    <DataTable
      :dropdown=false
      :tableHeader=true
      :tableHead=true
      tableActions="CUSTOMERS"
      tableAPI="CUSTOMERS"
      :actionsOptions="actionsOptions"
      :totalCount="totalCount"
      :checkbox=true
      :type=type
      :count="get_customers_count"
      :list="get_customers_list"
      :rowActionParameter="rowActionParameter"
      :referenceData="referenceData"
      :filterOptions="filterOptions"
      :customTable=false
      :updateIterator="updateIterator"
      @updatedSelections="tableSelectionsUpdated"
      @actionOptionTriggered="actionOptionTriggered"
      @rowAction="rowAction" />
    <Popup
      v-if="openImport"
      :showConfirmButton="showImportButton && !get_error_message"
      :confirmText="$t('import')"
      @cancel="togglePopupEdit"
      @confirm="submitForm">
      <template v-slot:header>
        <h2>{{ $t('Import Template') }}</h2>
      </template>
      <UploadTemplate
        @enabeImport="enableImport"
        @disableImport="showImportButton = false"
        @closePopup="closePopupAndTrackImportProcess"
        @uploaded="updateTableAfterUpload"
        templateType="customer_fields" />
        <message v-if="get_error_message.type" name="warning" :data="get_error_message"></message>
    </Popup>
    <Popup
      v-if="openCreatePopup"
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      @cancel="closeNewCustomer"
      @confirm="addContactForm">
      <template v-slot:header>
        <h2>{{ $t('Create new contact') }}</h2>
      </template>
      <div>
        <div class="row m-b-20">
          <div class="col-xs-12 m-b-20">
            <InputSelect
              :label="$t('type')"
              v-model="createType"
              @change="changeCreateType"
              :options="typeOptions"
              :rules="{required: true}"/>
          </div>
          <InputText
            v-if="createType == 1"
            class="col-xs-12 m-b-20"
            :label="$t('company')"
            v-model="contact.company_name"
            :rules="{required: createType == 1}"/>
          <InputText
            class="col-xs-12"
            :label="$t('name')"
            v-model="contact.name"
            :rules="{required: true}"/>
        </div>
        <AddressPicker
          class="m-b-input m-b-20"
          :label="$t('address_1')"
          placeholder="Search address"
          @addressSelected="changeAddress($event)"
          v-model="contactAddress" />
        <div class="row m-b-20">
          <InputText
            class="col-xs-12 m-b-20"
            label="Email"
            v-model="contact.email"
            :rules="{required: true, email: true}"/>
          <PhoneSelect key="contactPhone" class="col-xs-12  m-b-20" v-model="contact.phone" :rules="{required: true}"/>
          <InputText
            v-if="createType == 1"
            class="col-xs-12 m-b-20"
            label="Vat"
            v-model="contact.vat"
            :rules="{required: false}"/>
          <InputText
            class="col-xs-12"
            label="External customer no"
            v-model="contact.external_customer_no"
            :rules="{required: false}"/>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mixin from '@/mixins/mixins.js';
import Dropdown from '@/components/global/dropdown';
import Popup from '@/components/global/popup';
import DataTable from '@/components/table/index.vue';
import UploadTemplate from '@/components/global/uploadTemplate';
import AddressPicker from '@/components/global/addressPicker/index.vue';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import EventBus from '@/eventBus.js';

import stateList from '@/data/state.js';
import formValidator from '@/mixins/formValidator';

/* eslint-disable */
export default {
  name: 'Contacts',
  components: {
    DataTable,
    Dropdown,
    Popup,
    UploadTemplate,
    AddressPicker,
    InputText,
    PhoneSelect,
    InputSelect,
  },
  mixins: [mixin,formValidator],
  data() {
    return {
      updateIterator: 1,
      isTableAllSelected: false,
      selectedItems: [],
      openCreatePopup: false,
      showImportButton: false,
      totalCount: 300,
      rowActionParameter: {
        param: 'id',
        text: `${this.$t('View contact')}`,
      },
      type: {
        type: true,
        data: 'type', // generate_invoice_spec_file_type
        text: `${this.$t('type')}`,
        icons: {
          1: 'building',
          2: 'single',
        },
      },
      referenceData: [
        {
          name: `${this.$t('name')}`,
          address_1: `${this.$t('address')}`
        },
        {
          shipments_count: `${this.$t('Shipments')}`,
          last_shipment: `${this.$t('Last trade')}`,
        },
        {
          country: `${this.$t('country')}`,
          delivery_addresses_count: `${this.$t('contacts')}`,
        },
      ],
      openImport: false,
      dropdownOptions: [
        {
          text: `${this.$t('Create Contact')}`,
          subText: `${this.$t('Type in manually')}`,
          icon: 'plus',
        },
        {
          text: `${this.$t('Import Contacts')}`,
          subText: `${this.$t('Bulk import from file')}`,
          icon: 'cloudUpload',
        }
      ],
      actionsOptions: [
        {
          text: `${this.$t('delete')}`,
          subText: `${this.$t('Delete selections')}`,
          icon: 'deleteForever',
        },
      ],
      contactAddress: {
        address_1: '',
        address_2: '',
        country_id: '',
        post_code: '',
        city: '',
        state: '',
      },
      contact: {
        name: '',
        company_name: '',
        email: '',
        phone: {
          number: '',
          country: '',
        },
        external_customer_no: ''
      },
      createType: 2,
      typeOptions: [
        {
          text: `${this.$t('Private')}`,
          value: 2,
        },
        {
          text: `${this.$t('Business')}`,
          value: 1,
        }
      ],
      alternativeAddress:{
        company_name: '',
        name: '',
        address_1: '',
        address_2: '',
        city: '',
        post_code: '',
        country_id: '',
        phone: '',
        email: '',
        state: '',
      }
    };
  },
  computed: {
    ...mapGetters([
      'get_error_message',
      'get_customers_list',
      'get_customers_count',
      'get_filters_menu',
      'get_active_filter',
      'get_active_subaccount',
      'get_import_queue',
      'get_all_shipments_query',
    ]),
    isPopupSubmitDisabled() {
      if (this.contact.phone.number.length < 6) return true;
      let formWithValidators = [
        {
          formFeild: 'country_id',
          value: this.contactAddress.country_id,
          validators: {required: true}
        },
        {
          formFeild: 'post_code',
          value: this.contactAddress.post_code,
          validators: {required: true}
        },
        {
          formFeild: 'city',
          value: this.contactAddress.city,
          validators: {required: true}
        },
        {
          formFeild: 'address_1',
          value: this.contactAddress.address_1,
          validators: {required: true}
        },
        {
          formFeild: 'type',
          value: this.createType,
          validators: {required: true}
        },
        {
          formFeild: 'name',
          value: this.contact.name,
          validators: {required: true}
        },
        {
          formFeild: 'phone',
          value: this.contact.phone.number,
          validators: {required: true}
        },
        {
          formFeild: 'email',
          value: this.contact.email,
          validators: {required: true, email: true}
        }
      ]

      if (this.createType == 1) {
        formWithValidators.push({
          formFeild: 'company_name',
          value: this.contact.company_name,
          validators: {required: true}
        })
      } else {
        formWithValidators.filter((item) => item.formFeild != 'company_name')
      }
      return this.validateInput(formWithValidators);
    },
    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'customer',
        tableApi: 'customer/get-list',
        filterFields: {
          type: {
            label: `${this.$t('type')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('Business')}`, value: '1'},
              {text: `${this.$t('Private')}`, value: '2'},
            ],
          },
          shipments_count: {
            label: `${this.$t('shipments_count')}`,
            type: 'options',
            value: {
              value: '',
              additional: '',
            },
          },
          company_name: {
            label: `${this.$t('company_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          name: {
            label: `${this.$t('name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          address_1: {
            label: `${this.$t('address_1')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          post_code: {
            label: `${this.$t('post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          city: {
            label: `${this.$t('city')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          country: {
            label: `${this.$t('country')}`,
            type: 'country',
            value: {
              value: [],
              additional: '',
            },
          },
          phone: {
            label: `${this.$t('phone')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          email: {
            label: 'Email',
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          external_customer_no: {
            label: 'External customer no',
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
        },
        actionsOptions: [
          {
            text: `${this.$t('delete')}`,
            subText: `${this.$t('Delete selections')}`,
            icon: 'deleteForever',
          },
        ],
      }
    },
  },
  methods: {
    // Table actions
    updateTableAfterUpload() {
      this.updateIterator++;
    },
    tableSelectionsUpdated(val) {
      this.selectedItems = val.selectedList;
      this.isTableAllSelected = val.selectTotalRows;
    },
    actionOptionTriggered(option) {
      if (option.dropOption == 'dropOption1') {
        // Delete
        if (this.isTableAllSelected) {
          this.$store.dispatch('DELETE_CUSTOMERS', {
            type: 'byFilter',
            search: this.$route.query.search,
            searchTerm: this.$route.query.searchTerm,
            count: this.get_customers_count,
          }).then(() => {
            this.updateIterator++
          });
        } else {
          this.$store.dispatch('DELETE_CUSTOMERS', {
            type: 'byId',
            id: 0,
            ids: option.list,
          }).then(() => {
            this.updateIterator++
          });
        }
      }
    },
    changeCreateType(val) {
      if (val == 2) {
        this.contact.company_name = '';
      }
    },
    addContactForm() {
      const form = {
        ...this.contactAddress,
        type: this.createType,
        subaccount_id: this.get_active_subaccount.id,
        name: this.contact.name,
        company_name: this.contact.company_name,
        email: this.contact.email,
        phone: this.contact.phone.number,
        vat: this.contact.vat,
        external_customer_no: this.contact.external_customer_no,
        alternativeAddress: this.alternativeAddress,
      }

      this.$store.dispatch('ADD_CUSTOMER', form).then(() => {
        this.resetContactForm();
        this.updateIterator++;
        this.openCreatePopup = false;
      });
    },
    changeAddress(val) {
      this.contactAddress.address_1 = val.address_1 || '';
      this.contactAddress.address_2 = val.address_2 || '';
      this.contactAddress.country_id = val.country_id || '';
      this.contactAddress.post_code = val.post_code || '';
      this.contactAddress.city = val.city || '';

      let flag = false;
      stateList.forEach((state) => {
        if (state.country_name == this.getCountry(val.country_id, 'name')) {
          flag = true;
        }
      });

      if (flag) {
        this.contactAddress.state = val.state;
      } else {
        this.contactAddress.state = '';
      }
    },
    rowAction(val) {
      this.$router.push(`/contacts/contact/${val}`);
    },
    optionSelected(opt) {
      if (opt === 'dropOption1') {
        this.createNewCustomer();
      }
      if (opt === 'dropOption2') {
        this.openImportTemplatePopup();
      }
      // if (opt === 'dropOption3') {
      //   this.downloadCsv()
      // }
    },
    // downloadCsv() {
    //   //export file should be done only from reports page but leave it for now if daniel change his mind :D  (22.5.2023)
    //
    //   this.$store.dispatch('EXPORT_CSV', {
    //     tableName: 'customer_contacts',
    //     ids: this.selectedItems,
    //     ids: this.selectedItems,
    //   }).then((res) => {
    //     this.$nextTick(() => {
    //       const blob = new Blob([res], {type: "octet/stream"});
    //       const url = window.URL.createObjectURL(blob);
    //       const link = document.createElement('a');
    //       link.href = url;
    //       link.setAttribute('download', 'Contacts.csv');
    //       document.body.appendChild(link);
    //       link.click();
    //       setTimeout(() => {
    //         document.body.removeChild(link);
    //         window.URL.revokeObjectURL(url);
    //       }, 200);
    //     })
    //   });
    // },
    closePopupAndTrackImportProcess() {
      this.togglePopupEdit();
    },
    togglePopupEdit() {
      this.openImport = !this.openImport;
    },
    createNewCustomer() {[]
      // this.$router.push('/contacts/add-new');
      this.openCreatePopup = true;
    },
    closeNewCustomer() {
      this.resetContactForm();
      this.openCreatePopup = false;
    },
    enableImport() {
      this.showImportButton = true;
    },
    submitForm() {
      EventBus.$emit('import_template');
    },
    openImportTemplatePopup() {
      this.openImport = true;
      this.$store.dispatch('GET_TEMPLATES');
    },
    resetContactForm() {
      this.contact = {
        name: '',
        company_name: '',
        email: '',
        phone: {
          number: '',
          country: '',
        },
        external_customer_no: ''
      }

      this.contactAddress = {
        address_1: '',
        address_2: '',
        country_id: '',
        post_code: '',
        city: '',
        state: '',
      }

      this.createType = 2
    }
  },
  watch: {
    get_import_queue: {
      handler(newValue) {
        newValue.forEach(queObj => {
          if(queObj.templateType == 'contact_fields' && queObj.progressStatus == 100) {
            this.updateIterator++;
          }
        })

      },
      deep: true
    }
  }
};
</script>
